import { render, staticRenderFns } from "./ContentFlow.vue?vue&type=template&id=65e38f92&scoped=true&"
import script from "./ContentFlow.vue?vue&type=script&lang=js&"
export * from "./ContentFlow.vue?vue&type=script&lang=js&"
import style0 from "./ContentFlow.vue?vue&type=style&index=0&id=65e38f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e38f92",
  null
  
)

export default component.exports